import {
  INamedDocument,
  ISoftDelete,
  Timestamp,
} from '@principle-theorem/shared';
import { IStaffer } from '../staffer/staffer';

export enum MarketingCampaignEntryLogEvent {
  StatusChange = 'statusChange',
  RunTransfer = 'runTransfer',
}

export interface IMarketingCampaignEntryLog extends ISoftDelete {
  timestamp: Timestamp;
  event: MarketingCampaignEntryLogEvent;
  message?: string;
  performedBy?: INamedDocument<IStaffer>;
}
